import React from 'react';
import { Skeleton } from '@strivelabs/ui-core';

type LoadingSkeletonProps = {
  rows?: number;
};

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ rows = 6 }) => (
  <div className="max-h-[600px] overflow-y-auto rounded-lg border border-border bg-card">
    <div className="divide-y divide-border">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="p-4 space-y-2">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  </div>
);

export default LoadingSkeleton;
